/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable @typescript-eslint/no-unused-vars, no-restricted-syntax */
import { DocumentNode } from 'graphql';
import * as Types from '../../../types/definitions/vendor/graphql-schema.d';

export type ShopProductVariantFragmentFragment = {
  __typename?: 'ShopProductVariant';
  id: string;
  sku: string;
  url: string;
  saved: boolean;
  media: {
    __typename?: 'ShopMedia';
    altText: string;
    contentType: Types.MediaContent;
    originalSrc: string;
    position: number;
    category: string;
    group: string;
    label: string;
    modelSize?: {
      __typename?: 'MediaModel';
      dress?: string | null;
      height: string;
      waist?: string | null;
      alphaSizeName: string;
    } | null;
  }[];
  color: {
    __typename?: 'Color';
    uniqueColorId: string;
    name: string;
    swatch: { __typename?: 'ColorSwatch'; hex: string; url?: string | null };
  };
  size: { __typename?: 'Size'; name: string };
  inseam?: { __typename?: 'Inseam'; name: string } | null;
  detailGroups: {
    __typename?: 'ProductDetailGroup';
    key: string;
    label: string;
    details: {
      __typename?: 'ProductDetail';
      key: string;
      label: string;
      value: string;
    }[];
  }[];
};

export const ShopProductVariantFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopProductVariantFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopProductVariant' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'altText' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'category' },
                  name: { kind: 'Name', value: 'contentName' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'group' },
                  name: { kind: 'Name', value: 'contentGroup' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'label' },
                  name: { kind: 'Name', value: 'contentName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'modelSize' },
                  name: { kind: 'Name', value: 'mediaModel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'alphaSizeName' },
                        name: { kind: 'Name', value: 'alpha' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dress' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'height' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'waist' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'originalSrc' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uniqueColorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'swatch' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'size' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inseam' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'detailGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'details' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
